import api from './api';

export interface AppNotification {
  id: number;
  user_id: string;
  type: 'case_assigned' | 'task_assigned' | 'case_event_added' | 'case_document_added' | string;
  title: string;
  message: string | null;
  link: string | null;
  data: Record<string, unknown> | null;
  read_at: string | null;
  created_at: string;
  updated_at: string;
}

interface NotificationsListResponse {
  status: boolean;
  message: string;
  data: AppNotification[];
  unread_count: number;
}

const notificationsService = {
  getNotifications: async (userId: string, limit = 30): Promise<NotificationsListResponse> => {
    const response = await api.get(`/notifications/${userId}`, { params: { limit } });
    return response.data;
  },

  getUnreadCount: async (userId: string): Promise<number> => {
    const response = await api.get(`/notifications/${userId}/unread-count`);
    return response.data.unread_count;
  },

  markAsRead: async (id: number, userId: string) => {
    const response = await api.put(`/notifications/${id}/read/${userId}`);
    return response.data;
  },

  markAllAsRead: async (userId: string) => {
    const response = await api.put(`/notifications/read-all/${userId}`);
    return response.data;
  },
};

export default notificationsService;
